import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ProjectBreadcrumbs from '../components/ProjectBreadcrumbs';

function SemanaHipHopEdicao({ edicao }) {
  const galeria = edicao.galeria?.length
    ? edicao.galeria
    : [
        'Foto de palco ou show',
        'Foto de oficinas ou atividades',
        'Peça gráfica ou material de divulgação'
      ];

  return (
    <div className="week-page week-edition-page">
      <section className="week-hero week-edition-hero">
        <Container>
          <Row>
            <Col>
              <ProjectBreadcrumbs
                items={[
                  { label: 'Projetos', to: '/projetos' },
                  { label: 'Semana do Hip Hop', to: '/projetos/semana-do-hip-hop' },
                  { label: edicao.titulo }
                ]}
              />
            </Col>
          </Row>
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="week-hero-copy">
                <span className="week-kicker">Memória da edição</span>
                <h1>{edicao.titulo}</h1>
                <p>{edicao.chamada}</p>
                <div className="week-tags">
                  <span>{edicao.ano}</span>
                  <span>Semana do Hip Hop de Bauru</span>
                  <span>{edicao.titulo}</span>
                </div>
                <Link
                  className="week-back-link"
                  to="/projetos/semana-do-hip-hop"
                  state={{ scrollTargetId: `edicao-card-${edicao.slug}` }}
                >
                  Voltar para o projeto
                </Link>
              </div>
            </Col>
            <Col lg={5}>
              <div className="week-edition-hero-logo">
                <div className="week-edition-logo-placeholder large">
                  <span>Espaço para logo da {edicao.titulo}</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="week-content-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={8}>
              <div className="week-text-panel">
                <p>{edicao.resumo}</p>
                {edicao.descricao.map((paragrafo) => (
                  <p key={paragrafo}>{paragrafo}</p>
                ))}
              </div>
            </Col>
            <Col lg={4}>
              <div className="week-side-stack">
                <div className="week-highlight-card">
                  <span className="week-highlight-label">Preenchimento sugerido</span>
                  <ul>
                    {edicao.destaques.map((destaque) => (
                      <li key={destaque}>{destaque}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="week-gallery-section">
        <Container>
          <div className="week-section-heading">
            <span>Registros</span>
            <h2>Espaços reservados para esta edição</h2>
          </div>
          <Row className="g-4">
            {galeria.map((item) => (
              <Col md={4} key={item}>
                <div className="week-gallery-card">
                  <div className="week-photo-placeholder large">
                    <span>{item}</span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
}

SemanaHipHopEdicao.propTypes = {
  edicao: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    ano: PropTypes.number.isRequired,
    chamada: PropTypes.string.isRequired,
    resumo: PropTypes.string.isRequired,
    descricao: PropTypes.arrayOf(PropTypes.string).isRequired,
    destaques: PropTypes.arrayOf(PropTypes.string).isRequired,
    galeria: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};

export default SemanaHipHopEdicao;